import http from "../helpers/http-common"

class ReportsDataService {

    getList(params) {
        return http.post(`/reports/list`, params)
    }

    getStats(params) {
        return http.post(`/reports/stats`, params)
    }

    review(reportId, params) {
        return http.post(`/reports/${reportId}/review`, params)
    }

    close(reportId, params) {
        return http.post(`/reports/${reportId}/close`, params)
    }

    sendReply(reportId, params) {
        return http.post(`/reports/${reportId}/reply`, params)
    }
}

export default new ReportsDataService();